import React from 'react';
import { ReceiptText } from 'lucide-react';
import { S } from '../constants';
import { TAX_REFUND, taxRefundLang, resolveTaxRefundKey } from '../constants/taxRefund';

// Country-level tourist tax-refund rules (official sources only — see constants/taxRefund.js).
// `country` may be any spelling the app uses (English key, or the geocoder's UI-language name);
// `city` lets Hong Kong / Macau (which report "China") be excluded. Renders nothing when unknown.
export const TaxRefundCard = ({ country, city, lang }) => {
  const key = resolveTaxRefundKey(country, city);
  const d = key && TAX_REFUND[key];
  if (!d) return null;
  const L = taxRefundLang(lang);
  const pick = v => (v && typeof v === 'object') ? v[L] : v;
  return (
    <div style={{ ...S.card, padding:'14px 16px', display:'flex', alignItems:'flex-start', gap:12, marginTop:10 }}>
      <div style={{ width:36,height:36,background:'#fff7ed',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:2 }}>
        <ReceiptText size={16} color="#c2410c"/>
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', margin:'0 0 6px' }}>
          <span style={{ fontSize:10,fontWeight:900,textTransform:'uppercase',letterSpacing:1.5,color:'#64748b' }}>{L==='en' ? 'Tax refund for tourists' : '購物退稅'}</span>
          {d.tag && <span style={{ background:'#fff7ed',color:'#9a3412',border:'1px solid #fed7aa',borderRadius:6,padding:'1px 8px',fontSize:11,fontWeight:800 }}>{pick(d.tag)}</span>}
        </div>
        <ul style={{ margin:0, paddingLeft:18, display:'flex', flexDirection:'column', gap:4 }}>
          {d[L].map((line,i)=>(
            <li key={i} style={{ fontSize:12, fontWeight:600, color:'#334155', lineHeight:1.6, wordBreak:'break-word' }}>{line}</li>
          ))}
        </ul>
        {d.note && (
          <p style={{ margin:'8px 0 0', background:'#fff7ed', border:'1px solid #fed7aa', color:'#9a3412', borderRadius:8, padding:'6px 10px', fontSize:11.5, lineHeight:1.5 }}>{pick(d.note)}</p>
        )}
        <p style={{ margin:'8px 0 0', fontSize:11, color:'#94a3b8', lineHeight:1.6 }}>
          {L==='en' ? 'Official sources: ' : '官方來源：'}
          {d.sources.map((s,i)=>(
            <React.Fragment key={s.url}>
              {i>0 && ' · '}
              <a href={s.url} target="_blank" rel="noopener noreferrer" style={{ color:'#1677ff', fontWeight:700, textDecoration:'none' }}>{pick(s.label)}</a>
            </React.Fragment>
          ))}
          {' · '}{L==='en' ? 'Checked' : '核對日期'} {d.verified}
        </p>
      </div>
    </div>
  );
};
